export const Nodedata = [
  {
    title: "topics   Intro & Setup",
    subtitle: " Topics Introduction & Setup",
    filepath: "/nodejs/topics.md",
    content:
      "The MERN stack is a popular web development stack that consists of MongoDB, Express.js, React.js, and Node.js.",
  },
  {
    title: "Networking  Basics",
    subtitle: "Networking",
    filepath: "/nodejs/Networking.md",
  },
  {
    title: "Node Intro & Setup",
    subtitle: "Node.js Introduction & Setup",
    filepath: "/nodejs/1-intro.md",
    content:
      "Node.js is a JavaScript runtime built on Chrome's V8 JavaScript engine. It allows developers to run JavaScript on the server side.",
  },
  {
    title: "Http",
    subtitle: "Http",
    filepath: "/nodejs/Http.md",
    content:
      "HTTP (Hypertext Transfer Protocol) is the foundation of data communication on the web. It is a protocol used for transmitting hypertext via the internet.",
  },
  {
    title: "Http Headers",
    subtitle: "Http Headers",
    filepath: "/nodejs/http-header.md",
  },
  {
    title: "Http Status Codes",
    subtitle: "Http Status Codes",
    filepath: "/nodejs/Http-statuscode.md",
  },
  {
    title: "Http and express",
    subtitle: "http and express",
    filepath: "/nodejs/http-express.md",
    content:
      "Express.js is a web application framework for Node.js that simplifies the process of building web applications and APIs.",
  },
  {
    title: "'Restful' APIs",
    subtitle: "Restful APIs",
    filepath: "/nodejs/rest-api.md",
    content:
      "Express.js is a web application framework for Node.js that simplifies the process of building web applications and APIs.",
  },
  {
    title: "Middleware",
    subtitle: "Middleware",
    filepath: "/nodejs/middleware.md",
  },
  {
    title: "Some more topics",
    subtitle: "Some more topics",
    filepath: "/nodejs/topics.md",
    content:
      "Express.js is a web application framework for Node.js that simplifies the process of building web applications and APIs.",
  },
];
